import { ACTION_TYPES } from './types';
import { Action, GetState } from '../types';
import { CaseDetails } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import { Dispatch } from 'react';
import { AxiosResponse } from 'axios';
import { CaseResponseData } from 'modules/cm/api/cases/types';
import { caseFromApi, resourcesFromApi } from '../mapper';

export const historyPushDispatcher = (dispatch: Dispatch<Action>, getState: GetState) => (
  res: AxiosResponse<CaseResponseData>,
) => {
  const resources = resourcesFromApi(res.data.resources);
  const caseDetails: CaseDetails = {
    case: caseFromApi(res.data.case),
    resources,
  };

  return dispatch(push(caseDetails));
};

export const push = (payload: CaseDetails): Action => ({
  type: ACTION_TYPES.PUSH,
  payload: [payload, null],
});
